'use client';

import { useContext, createContext } from 'react';

const DeviceContext = createContext({
  deviceType: 'desktop'
});

export function useDevice() {
  return useContext(DeviceContext);
}

export { DeviceContext };
